import {
  APPOINTMENTS_ALL,
  APPOINTMENTS_ALL_SUCCESS,
  APPOINTMENTS_CREATE,
  APPOINTMENTS_CREATE_SUCCESS,
  APPOINTMENTS_DELETE,
  APPOINTMENTS_DELETE_SUCCESS,
  APPOINTMENTS_GET,
  APPOINTMENTS_GET_AGENDA,
  APPOINTMENTS_GET_AGENDA_FAILED,
  APPOINTMENTS_GET_AGENDA_SUCCESS,
  APPOINTMENTS_GET_BY_DATES,
  APPOINTMENTS_GET_BY_DATES_FAILED,
  APPOINTMENTS_GET_BY_DATES_SUCCESS,
  APPOINTMENTS_GET_SUCCESS,
  APPOINTMENTS_UPDATE,
  APPOINTMENTS_UPDATE_SUCCESS,
} from '../constants/Appointments';

const initialState = {
	appointment: {
		id: null,
		customer_id: null,
		from: null,
		to: null,
		description: null,
		label_color: null,
	},
	appointments: null,
	byDates: {
		from: null,
		to: null,
		appointments: null,
	},
	agenda: [],
	perPage: 10,
	from: 0,
	to: 0,
	page: 1,
	loading: false,
};

const appointments = (state = initialState, action) => {
	switch (action.type) {
		case APPOINTMENTS_ALL:
			return {
				...state,
				perPage: action.perPage,
				page: action.page,
				loading: true,
			};
		case APPOINTMENTS_ALL_SUCCESS:
			return {
				...state,
				appointments: action.appointments,
				total: action.total,
				from: action.from,
				to: action.to,
				loading: true,
			};
		case APPOINTMENTS_GET:
			return {
				...state,
			};
		case APPOINTMENTS_GET_SUCCESS:
			return {
				...state,
				appointment: action.appointment,
				loading: false,
			};
		case APPOINTMENTS_GET_BY_DATES:
			return {
				...state,
				byDates: {
					from: action.start,
					to: action.end,
				},
				loading: true,
			};
		case APPOINTMENTS_GET_BY_DATES_SUCCESS:
			return {
				...state,
				byDates: {
					...state.byDates,
					appointments: action.appointments,
				},
				loading: false,
			};
		case APPOINTMENTS_GET_BY_DATES_FAILED:
			return {
				...state,
				loading: false,
			};
		case APPOINTMENTS_CREATE:
			return {
				...state,
			};
		case APPOINTMENTS_CREATE_SUCCESS:
			return {
				...state,
				byDates: {
					...state.byDates,
					appointments: [...state.byDates.appointments, action.appointment],
				},
			};
		case APPOINTMENTS_UPDATE:
			return {
				...state,
			};
		case APPOINTMENTS_UPDATE_SUCCESS:
			return {
				...state,
				byDates: {
					...state.byDates,
					appointments: state.byDates.appointments
						? state.byDates.appointments.map((a) =>
								a.id === action.appointment.id ? action.appointment : a
						  )
						: [],
				},
				agenda: state.agenda
					? state.agenda.map((a) =>
							a.id === action.appointment.id ? action.appointment : a
					  )
					: [],
				appointments: state.appointments
					? state.appointments.map((a) =>
							a.id === action.appointment.id ? action.appointment : a
					  )
					: [],
			};
		case APPOINTMENTS_GET_AGENDA:
			return {
				...state,
				loading: true,
			};
		case APPOINTMENTS_GET_AGENDA_SUCCESS:
			return {
				...state,
				agenda: action.agenda,
				loading: false,
			};
		case APPOINTMENTS_GET_AGENDA_FAILED:
			return {
				...state,
				loading: false,
			};
		case APPOINTMENTS_DELETE:
			return {
				...state,
			};
		case APPOINTMENTS_DELETE_SUCCESS:
			return {
				...state,
				appointments: state.appointments
					? state.appointments.filter((a) => a.id !== action.id)
					: [],
				byDates: {
					...state.byDates,
					appointments: state.byDates.appointments
						? state.byDates.appointments.filter((a) => a.id !== action.id)
						: [],
				},
				agenda: state.agenda
					? state.agenda.filter((a) => a.id !== action.id)
					: [],
			};
		default:
			return state;
	}
};

export default appointments;
